import ActionCable from "actioncable";

// Authenticated cable consumer for the CRM agent chat — connects with the same
// access token GraphQL uses, passed as a query param since WebSockets can't set
// headers. The backend's ApplicationCable::Connection decrypts it to current_user.
let consumer = null;

function wsUrl() {
  const base = process.env.VUE_APP_WS_URL || "ws://localhost:3010/cable";
  const token = sessionStorage.getItem("access_token") || "";
  if (!token) return base;
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}token=${encodeURIComponent(token)}`;
}

// Subscribe to the shared agent stream. `onData(payload)` fires on every chat event
// (message | nudge | read | status). Returns the subscription (call .unsubscribe()).
export function subscribeAgentChat(onData) {
  if (!consumer) consumer = ActionCable.createConsumer(wsUrl());
  return consumer.subscriptions.create(
    { channel: "AgentChatChannel" },
    { received(data) { try { onData(data); } catch (e) { /* ignore */ } } }
  );
}
